import { atom } from "recoil";

export const originalPathState = atom({
  key: "path",
  default: "/",
});

export const accessTokenState = atom({
  key: "accessToken",
  default: "",
});

export const linkOrgIdState = atom({
  key: "linkOrgId",
  default: "",
});

export const linkOrgUserIdState = atom({
  key: "linkOrgUserId",
  default: "",
});

export const developerIdTokenState = atom({
  key: "developerIdToken",
  default: "",
});

export const developerAccessTokenState = atom({
  key: "developerAccessToken",
  default: "",
});

export const developerEmailState = atom({
  key: "developerEmail",
  default: "",
});

export const userInfoState = atom({
  key: "userInfo",
  default: {},
});
